import React, { useEffect } from 'react'

import { AppAsyncOfficesAutocomplete } from '@components'
import {errors, officesPickoff, showDropoffOffice} from '@signals'
import {batch} from "@preact/signals-react";


export default function AppCommonFiltersDropoffOfficesAutocomplete({ ...props }) {

	useEffect(() => {
		if(!showDropoffOffice.value) officesPickoff.value = null
	}, [showDropoffOffice.value])

	return <AppAsyncOfficesAutocomplete
		value={officesPickoff.value}
		label="Dropoff Offices"
		error={errors.value?.offices}
		onChange={e => officesPickoff.value = e.target.value}
		filters={{
			id_office_dropoff: officesPickoff.value,
			...props?.filters
		}}
        inputProps={{
            onKeyDown: (e) => {
                if (!props.multiple && !!officesPickoff.value){
                    const allowedKeys = ['Tab','Shift', 'Control', 'Alt', 'Meta'];
                    if (allowedKeys.includes(e.key)) {
                        return;
                    }
                    e.preventDefault();
                    batch(() => {
                        officesPickoff.value = null;
                    });
                }
            }
        }}
		{...props}
	/>
}